import React, { FC, useEffect, useState } from 'react';
import { browserHistory } from 'react-router';
import { I18n } from 'react-redux-i18n';

import { getClassesForCssModule } from '@utils/customBEMHelper';
import { PaymentStatusPageProps } from './interfaces';
import { PAYMENT_STATUS_PATHS, REDIRECT_PATH } from './constants';
import request from 'superagent';

import styles from './styles.module.scss';

const classes = getClassesForCssModule('payment-status-banner', styles);

const PaymentStatusPage: FC<PaymentStatusPageProps> = ({ params }) => {
  const [isRu, setIsRu] = useState(false);
  const paymentStatus = params.status;

  const isPaymentCompleted = paymentStatus === PAYMENT_STATUS_PATHS.COMPLETED;
  const isPaymentFail = paymentStatus === PAYMENT_STATUS_PATHS.FAIL;

  if (!isPaymentCompleted && !isPaymentFail) {
    browserHistory.push(REDIRECT_PATH);
  }

  useEffect(() => {
    request.get('https://ipinfo.io/json').then(({ body }: any) => {
      setIsRu(body.country === 'RU');
    });
  }, []);

  const paymentStatusContent = isPaymentCompleted ? (
    <h1 className={classes('title')}>
      {I18n.t('shop.paymentStatus.successTitle')}
      <br />
      {I18n.t('shop.paymentStatus.successDesc')}
      <br />
      {isRu && (
        <div
          className="i-flocktory"
          data-fl-action="exchange"
          data-fl-spot="some_spot"
          data-fl-user-email="xname@flocktory.comL"
        />
      )}
    </h1>
  ) : (
    <h1 className={classes('title')}>
      {I18n.t('shop.paymentStatus.failTitle')}
      <br />
      {I18n.t('shop.paymentStatus.failDesc')}
    </h1>
  );

  return (
    <>
      <div className="container-fluid new-style select-plan code-gray-bg">
        <div className="container">
          <div className={classes()}>
            {paymentStatusContent}
            <div className={classes('present-box')}>
              <div className={classes('present-body')}>
                <div className={classes('present-title')}>
                  <span>{I18n.t('shop.present.cardTitle')}</span>
                </div>

                <div className={classes('present-desc')}>
                  <ol>
                    <li>{I18n.t('shop.present.title')}</li>
                    <li>{I18n.t('shop.present.desc')}</li>
                  </ol>
                  <span>
                    {I18n.t('shop.present.noRestrictions')} <br />
                    {I18n.t('shop.present.example')}
                  </span>
                </div>
              </div>
              <div className={classes('present-img')}>
                <img
                  src={require(`../../../assets/images/horse.png`)}
                  className=""
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentStatusPage;
